import { Alert, CircularProgress, Grid } from '@mui/material'

import Footer from '../footer'
import Header from '../header'

import classes from './index.styles'

interface ScreenProps {
  loading?: boolean
  error?: string
  useDarkBackground?: boolean
  shouldConstrainWidth?: boolean
  /** Header component if it is NOT the default header. If it is, use `headerProps` instead */
  header?: React.ReactNode
  showHeader?: boolean
  /** Props for the default header. Ignored if `header` is provided */
  headerProps?: typeof Header extends React.ComponentType<infer P> ? P : never
  footer?: React.ReactNode
  /** Space to add to the container's bottom padding to account for a fixed footer */
  footerSpacing?: number
  children: React.ReactNode | React.ReactNode[]
}

const ScreenContainer = (props: ScreenProps) => {
  const {
    loading,
    error,
    useDarkBackground,
    shouldConstrainWidth = true,
    header,
    showHeader = true,
    headerProps,
    footer,
    footerSpacing,
    children,
    ...rest
  } = props

  return (
    <Grid container={true} sx={[classes.containerRoot, useDarkBackground ? classes.mainGridWrapper : {}]} {...rest}>
      {showHeader && (header || <Header {...headerProps} />)}
      <Grid container={true} sx={[classes.routeWrapperGrid, shouldConstrainWidth ? classes.routeWrapperContainer : {}]}>
        <Grid sx={classes.contentGrid(footerSpacing)}>
          {loading ? (
            <Grid container={true} size={12} sx={classes.loadingGrid}>
              <CircularProgress sx={{ color: useDarkBackground ? 'common.white' : 'primary.main' }} />
            </Grid>
          ) : error ? (
            <Alert severity="error" sx={classes.errorAlert}>
              {error}
            </Alert>
          ) : (
            children
          )}
        </Grid>
      </Grid>

      {footer || <Footer />}
    </Grid>
  )
}

export default ScreenContainer
